<script>
  // It can be called from Play and Books
  export let sectionName

  import { selectedLanguage, userStore } from "../etc/store.js"
  // import { guabook1, guabook2 } from "../etc/gua64.js"
  import {
    guabook1tw,
    guabook2tw,
    guabook1cn,
    guabook2cn,
  } from "../etc/gua64.js"
  // import { zhouyi1, zhouyi2 } from "../etc/zhouyi.js"
  import { zhouyi1tw, zhouyi2tw, zhouyi1cn, zhouyi2cn } from "../etc/zhouyi.js"
  import GuaXuSong from "../books/GuaXuSong.svelte"
  import YinYao from "./YinYao.svelte"
  import YangYao from "./YangYao.svelte"
  import GuaSummary from "./GuaSummary.svelte"
  let isLogin = false

  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true
  } else {
    isLogin = false
  }

  let guabook1 = [...guabook1tw]
  let guabook2 = [...guabook2tw]
  let zhouyi1 = zhouyi1tw
  let zhouyi2 = zhouyi2tw

  $: if ($selectedLanguage == "TW") {
    guabook1 = [...guabook1tw]
    guabook2 = [...guabook2tw]
    zhouyi1 = zhouyi1tw
    zhouyi2 = zhouyi2tw
  } else {
    guabook1 = [...guabook1cn]
    guabook2 = [...guabook2cn]
    zhouyi1 = zhouyi1cn
    zhouyi2 = zhouyi2cn
  }
  let btn_style_top = "btn waves-effect waves-light teal darken-1 btn-single"
  let btn_style_book1 = "btn waves-effect waves-light blue darken-1 btn-single"
  let btn_style_book2 =
    "btn waves-effect waves-light purple lighten-1 btn-single"
  let btn_style_guest =
    "btn waves-effect waves-light grey-text blue-grey darken-1 btn-single"

  let question
  let showGuaXuSong = false
  let showBook1 = false
  let showBook2 = false
  let showDetail = false
  let showAllBtns = true

  let gua_id = ""
  let gua_code = ""
  let gua_name = ""
  let gua_fullName = ""
  let gua_gua = ""
  let gua_tuan = ""
  let gua_xiang = ""
  let gua_yao1 = ""
  let gua_yao2 = ""
  let gua_yao3 = ""
  let gua_yao4 = ""
  let gua_yao5 = ""
  let gua_yao6 = ""
  let gua_yaoXiang1 = ""
  let gua_yaoXiang2 = ""
  let gua_yaoXiang3 = ""
  let gua_yaoXiang4 = ""
  let gua_yaoXiang5 = ""
  let gua_yaoXiang6 = ""
  let gua_yong9 = ""
  let gua_yong6 = ""

  let got_book = ""
  let x_code = ""
  $: basicNumStr = ""

  function showTop(item) {
    showAllBtns = true
    if (item == "guaxusong") {
      showGuaXuSong = !showGuaXuSong
      showBook1 = false
      showBook2 = false
      got_book = ""
    } else if (item == "guabook1") {
      showGuaXuSong = false
      showBook1 = !showBook1
      showBook2 = false
      got_book = guabook1
    } else if (item == "guabook2") {
      showGuaXuSong = false
      showBook1 = false
      showBook2 = !showBook2
      got_book = guabook2
    } else {
      showGuaXuSong = false
      showBook1 = false
      showBook2 = false
      got_book = ""
    }
  }

  function showGua(code, book) {
    // alert(code);
    showAllBtns = false
    showDetail = !showDetail

    if (book == "guabook1") {
      gua_id = zhouyi1[code].id
      gua_code = zhouyi1[code].code
      gua_name = zhouyi1[code].name
      gua_fullName = zhouyi1[code].fullName
      gua_gua = zhouyi1[code].gua
      gua_tuan = zhouyi1[code].tuan
      gua_xiang = zhouyi1[code].xiang
      gua_yao1 = zhouyi1[code].yao1
      gua_yao2 = zhouyi1[code].yao2
      gua_yao3 = zhouyi1[code].yao3
      gua_yao4 = zhouyi1[code].yao4
      gua_yao5 = zhouyi1[code].yao5
      gua_yao6 = zhouyi1[code].yao6
      gua_yaoXiang1 = zhouyi1[code].yaoXiang1
      gua_yaoXiang2 = zhouyi1[code].yaoXiang2
      gua_yaoXiang3 = zhouyi1[code].yaoXiang3
      gua_yaoXiang4 = zhouyi1[code].yaoXiang4
      gua_yaoXiang5 = zhouyi1[code].yaoXiang5
      gua_yaoXiang6 = zhouyi1[code].yaoXiang6
      gua_yong9 = zhouyi1[code].yong9
      gua_yong6 = zhouyi1[code].yong6
    } else {
      gua_id = zhouyi2[code].id
      gua_code = zhouyi2[code].code
      gua_name = zhouyi2[code].name
      gua_fullName = zhouyi2[code].fullName
      gua_gua = zhouyi2[code].gua
      gua_tuan = zhouyi2[code].tuan
      gua_xiang = zhouyi2[code].xiang
      gua_yao1 = zhouyi2[code].yao1
      gua_yao2 = zhouyi2[code].yao2
      gua_yao3 = zhouyi2[code].yao3
      gua_yao4 = zhouyi2[code].yao4
      gua_yao5 = zhouyi2[code].yao5
      gua_yao6 = zhouyi2[code].yao6
      gua_yaoXiang1 = zhouyi2[code].yaoXiang1
      gua_yaoXiang2 = zhouyi2[code].yaoXiang2
      gua_yaoXiang3 = zhouyi2[code].yaoXiang3
      gua_yaoXiang4 = zhouyi2[code].yaoXiang4
      gua_yaoXiang5 = zhouyi2[code].yaoXiang5
      gua_yaoXiang6 = zhouyi2[code].yaoXiang6
      gua_yong9 = zhouyi2[code].yong9
      gua_yong6 = zhouyi2[code].yong6
    }

    basicNumStr = code2numStr(code)
    //console.log("@ Gua64: Rebuild default basic numStr = " + basicNumStr)

    let x = document.getElementById("showgua")
    let y = document.getElementById("top-to-hide")

    // console.log("code = " + code)
    // console.log("x_code = " + x_code)
    if (code != x_code) {
      x.style.display = "block"
      y.style.display = "none"
      showDetail = true
    } else {
      alert("same code: " + code)
      if (x.style.display == "none") {
        x.style.display = "block"
        y.style.display = "none"
      } else {
        x.style.display = "none"
        y.style.display = "block"
      }
    }

    // Auto scroll back to the top of the page
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }

  function backToBtns() {
    showAllBtns = true
    showDetail = false
  }

  function code2numStr(code) {
    let numStr = ""
    for (var i = 0; i < 6; i++) {
      if (code[i] == 0) {
        numStr = numStr + "8"
      } else {
        numStr = numStr + "7"
      }
    }
    return numStr
  }
</script>

<div id="top-to-hide" style="display:{showAllBtns ? 'block' : 'none'}">
  <!-- Begin Top Btn Row -->
  <div id="top-btns">
    {#if $selectedLanguage == "TW"}
      <button class={btn_style_top} on:click={() => showTop("guaxusong")}
        >卦序歌</button
      >
      <button
        class={btn_style_top}
        id="open-btn"
        on:click={() => showTop("guabook1")}>【上經】全展開</button
      >
      <button
        class={btn_style_top}
        id="open-btn"
        on:click={() => showTop("guabook2")}>【下經】全展開</button
      >
    {:else}
      <button class={btn_style_top} on:click={() => showTop("guaxusong")}
        >卦序歌</button
      >
      <button
        class={btn_style_top}
        id="open-btn"
        on:click={() => showTop("guabook1")}>【上经】全展开</button
      >
      <button
        class={btn_style_top}
        id="open-btn"
        on:click={() => showTop("guabook2")}>【下经】全展开</button
      >
    {/if}
    <!-- End Top Btn Row -->

    <!-- Begin Top Btn Content -->
    <div id="top-content">
      <div class="card indigo lighten-5">
        <div
          class="card-body note-content"
          style="display:{showGuaXuSong ? 'block' : 'none'}"
        >
          <GuaXuSong />
        </div>
      </div>

      <div class="card indigo lighten-5">
        <div
          class="card-body book-content"
          style="display:{showBook1 || showBook2 ? 'block' : 'none'}"
        >
          <ul>
            {#each got_book as { id, code, book, name, fullName, gua, tuan, xiang, yao1, yao2, yao3, yao4, yao5, yao6, yaoXiang1, yaoXiang2, yaoXiang3, yaoXiang4, yaoXiang5, yaoXiang6, yong9, yong6 }, i}
              <li>
                <div class="gua-row indigo lighten-4">
                  <div class="gua-1st-column">
                    <div class="gua-id">
                      {id} : {fullName}
                      <!-- ({code}) -->
                    </div>
                    <div class="gua-pic">
                      <div class=" guacard">
                        <div class=" guabox">
                          {#each [...code].reverse() as digit}
                            {#if digit == "0"}
                              <YinYao />
                            {:else}
                              <YangYao />
                            {/if}
                          {/each}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="gua-text">
                    <ul>
                      <li>{gua}</li>
                      <li>{tuan}</li>
                      <li>{xiang}</li>
                      {#if id === "1"}
                        <li>{yong9}</li>
                      {/if}
                      {#if id === "2"}
                        <li>{yong6}</li>
                      {/if}
                    </ul>
                  </div>
                </div>

                <div class="yao-box">
                  <ul>
                    <li>{yao6}</li>
                    <li>{yaoXiang6}</li>
                    <li>{yao5}</li>
                    <li>{yaoXiang5}</li>
                    <li>{yao4}</li>
                    <li>{yaoXiang4}</li>
                    <li>{yao3}</li>
                    <li>{yaoXiang3}</li>
                    <li>{yao2}</li>
                    <li>{yaoXiang2}</li>
                    <li>{yao1}</li>
                    <li>{yaoXiang1}</li>
                  </ul>
                </div>
              </li>{/each}
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- End Top Btn Row and Content -->

  <!-- Begin Gua Btn Row -->
  <div id="gua-btns">
    <div class="zouyi2">
      {#if $selectedLanguage == "TW"}
        <h5>【上經】</h5>
      {:else}
        <h5>【上经】</h5>
      {/if}
      {#if !isLogin}
        {#if $selectedLanguage == "TW"}
          <p>以下是會員功能。訪客可參考【15 地山謙】以瞭解部分的玩卦功能。</p>
        {:else}
          <p>以下是会员功能。访客可参考【15 地山谦】以了解部分的玩卦功能。</p>
        {/if}
      {/if}
      <div class="btn-row">
        {#each guabook1 as { code, fullName }, i}
          {#if isLogin || i == 14}
            <button
              class={btn_style_book1}
              on:click={() => showGua(code, "guabook1")}
              >{i + 1} {fullName}</button
            >
          {:else}
            <button class={btn_style_guest}>{i + 1} {fullName}</button>
          {/if}
        {/each}
      </div>
    </div>
    <div class="zouyi2">
      {#if $selectedLanguage == "TW"}
        <h5>【下經】</h5>
      {:else}
        <h5>【下经】</h5>
      {/if}

      <div class="btn-row">
        {#each guabook2 as { code, fullName }, i}
          {#if isLogin}
            <button
              class={btn_style_book2}
              on:click={() => showGua(code, "guabook2")}
              >{i + 31} {fullName}</button
            >
          {:else}
            <button class={btn_style_guest}>{i + 31} {fullName}</button>
          {/if}
        {/each}
      </div>
    </div>
    <!-- End Gua Btn Row -->
  </div>
</div>

<div
  class="showgua"
  id="showgua"
  style="display:{showDetail ? 'block' : 'none'}"
>
  <GuaSummary numStr={basicNumStr} {question} {sectionName} {isLogin} />
</div>

<style>
  .book-content {
    height: 500px;
    padding-left: 10px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
    font-size: 15px;
  }
  .gua-id {
    padding-left: 10px;
  }
  .gua-row {
    display: grid;
    grid-template-columns: 1fr 6fr;
    border-top: outset #7986cb 4px;
    border-bottom: solid #7986cb 2px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .yao-box {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .btn-single {
    width: 130px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  #close-btn {
    background-color: #aa55dd;
  }

  #open-btn {
    background-color: #44bb77;
  }
  .gua-results {
    margin: 20px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .guacard {
    margin: auto;
    padding-top: 10px;
    /* vertical-align: middle; */
    /* width: 35px;
    height: 70px;
    justify-content: space-between;
    justify-content: center; */
  }

  .guabox {
    flex: 1 1 150px;
    text-align: center;
    justify-content: center;
  }

  .gua-1st-column {
    border-right: solid #7986cb 2px;
    padding-right: 5px;
    padding-left: 5px;
  }
  .gua-text {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>
